import styled from "styled-components"

export default function BankAccountPolicy() {
  return (
    <Section>
      <Policy>{`모티너스 회원 계정으로 신한 챌린지를 참여하는 경우,\n챌린지 리워드(상금) 제공을 위해 아래와 같이 제휴사에\n개인(신용)정보를 제공합니다.`}</Policy>
      <Policy>{`1. 개인정보를 제공받는 자\n제휴사 신한은행`}</Policy>
      <Policy>{`2. 제공하는 개인정보 항목\n계좌번호, 이름(계좌주), 휴대폰번호, 상금 금액`}</Policy>
      <Policy>{`3. 개인정보를 제공받는 자의 개인정보 이용목적\n본인 명의 계좌 번호 인증, 상금 지급 등`}</Policy>
      <Policy>{`4. 개인정보를 제공받는 자의 개인정보 보유 및 이용기간\n회원 가입 기간동안 정보를 저장합니다. 단, 관계 법령의 규정에 의하여 일정 기간 보존이 필요한 경우에는 해단 기간만큼 보관 후 삭제합니다. 이령확인 및 분쟁조정(타인에 의한 정보 변경 등)을 위해 변경 전 본인확인 정보는 1년간 보관 후 파기 합니다.`}</Policy>
      <Policy>{`모티너스 회원은 위 개인정보 제공 동의를 거부할 권리가 있으나, 위 개인정보 제공 동의 거부 시 신한은행 챌린지의 리워드(상금) 지금이 불가능합니다. 그 밖의 내용은 모티너스 개인정보 처리방침을 따릅니다.`}</Policy>
    </Section>
  )
}

const Section = styled.div`
  padding: calc(100vw * (25 / 375)) calc(100vw * (17 / 375));
  height: 100%;
`

const Policy = styled.p`
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (17 / 375));
  white-space: pre-wrap;

  & + & {
    margin-top: calc(100vw * (20 / 375));
  }
`
